export const receiverMailOptions = [
  { label: 'Algemene vragen', value: 'Algemene Vragen' },
  { label: 'DumpertReeten', value: 'DumpertReeten' },
  { label: 'Dumpert Filmt je Werkplek', value: 'Dumpert Filmt Je Werkplek' },
  { label: 'Problemen met inloggen of registreren', value: 'problem' },
  { label: 'Reaguren', value: 'Reaguren' },
  { label: 'Sales', value: 'Sales' },
  { label: 'Verwijderverzoek', value: 'Verwijderverzoek' },
  { label: 'GDPR gegevens opvragen', value: 'gdpr' },
  { label: 'Vragen over de GDPR', value: 'Vragen over de GDPR' },
  { label: 'Anders', value: 'Anders' },
];

export const loginRegisterOptions = [
  { label: 'Ik heb problemen met...', value: '' },
  { label: 'Ik heb geen bevestigingsmail gekregen', value: 'no_confirm_mail' },
  { label: 'Wachtwoord herstellen', value: 'password_reset' },
  { label: 'Wachtwoord veranderen', value: 'password_change' },
  { label: 'Emailadres veranderen', value: 'email_change' },
  { label: 'Username veranderen', value: 'username_change' },
  { label: 'Account verwijderen / vergeten worden', value: 'delete_account' },
];

export const getExternalHref = (selected) => {
  const reaguurderUrl = 'https://reaguurder.nl';
  const urlPath = () => {
    switch (selected) {
      case 'no_confirm_mail':
        return '/email/versturen';
      case 'password_reset':
        return '/wachtwoord/vergeten';
      case 'username_change':
      case 'password_change':
      case 'email_change':
      case 'delete_account':
        return '/reaguurder/instellingen';
      case 'gdpr':
        return reaguurderUrl + '/contact';
      default:
    }
  };
  return `${urlPath()}`;
};
